import {defineMessages} from 'react-intl';

export default defineMessages({
	madeToOrder: {
		id: 'productTile.madeToOrder',
		defaultMessage: 'Made to order',
	}
});
